var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-ag-tooltip pa-4",style:({
    backgroundColor: _vm.backgroundColor,
    color: _vm.color,
    width: _vm.width,
  })},[(_vm.isHtmlContent)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.value)}}):_c('div',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }